<div class="mat-title" style="color: red; font-weight: bold">
    You have tried to access data or operations that you are not authorized for.</div>
<a href="javascript:void(0)" (click)="logout()" class="mat-subheading-1">Log out and log back in with another account.</a>